import { gql } from '@apollo/client';

export const GET_PROGRAMME_CHILD_PROGRAMMES = gql`
  query GetProgrammeChildProgrammes($id: ID!) {
    programme: getProgramme(id: $id) {
      childProgrammes {
        id
        name
      }
    }
  }
`;
